import type * as React from 'react';

import { createPalette, PaletteButton } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import type { ButtonProps } from '@gitbook/spine-react';

import {
    type UseChangeRequestNavigationCommandsProps,
    useChangeRequestActionsCommands,
    useChangeRequestCopyCommands,
    useChangeRequestNavigationCommands,
} from './commands';

export type ChangeRequestActionsButtonProps = UseChangeRequestNavigationCommandsProps &
    Omit<ButtonProps, 'onPress' | 'label'>;

/**
 * Button to display secondary actions relative to the change request in the context of the change requests listing screen.
 */
export function ChangeRequestActionsButton(
    props: ChangeRequestActionsButtonProps
): React.ReactElement {
    const { changeRequest, space, openInEditor, ...buttonProps } = props;

    const copyGroup = useChangeRequestCopyCommands({ changeRequest });
    const actionsGroup = useChangeRequestActionsCommands({ changeRequest });
    const navigationGroup = useChangeRequestNavigationCommands({
        space,
        changeRequest,
        openInEditor,
    });

    return (
        <PaletteButton
            palette={() =>
                createPalette({
                    groups: [navigationGroup(), actionsGroup(), copyGroup()],
                })
            }
            leadingIcon={Icon.MoreVertical}
            label="Change request actions"
            kind="blank"
            size="medium"
            iconOnly
            {...buttonProps}
        />
    );
}
